import 'css-chunksrc/client/pages/occupancyPage/styles.scss';export default {
  "occupancyPage": "_occupancyPage_1k220_1",
  "header": "_header_1k220_9",
  "profileNavigation": "_profileNavigation_1k220_19",
  "title": "_title_1k220_27",
  "menu": "_menu_1k220_33",
  "content": "_content_1k220_42",
  "tableContainer": "_tableContainer_1k220_53",
  "error": "_error_1k220_59",
  "empty": "_empty_1k220_60",
  "retry": "_retry_1k220_71"
};